import React from 'react';
import { isUserLoggedIn } from '../Utils/helper';
import { Navigate, Outlet } from 'react-router-dom'

const PublicRoutes = (props) => {
    const auth = isUserLoggedIn();
    return auth ? <Navigate to='/' /> : <Outlet />
}


export default PublicRoutes;;